<template>
  <div class="unscheduled-exams">
    <TheHeader class="unscheduled-exams__header" />
    <section class="unscheduled-exams__body">
      <div class="message-content">
        <BeakerLargeSvg class="message-content__icon" />
        <h1 class="message-content__text">Você tem exames para adicionar na recepção?</h1>
      </div>
      <footer class="resume-footer">
        <VNavButton
          variant="primary"
          text="Não, já adicionei todos"
          @click.native="triggerConfirmArriving"
        />
        <VNavButton
          variant="secondary"
          text="Preciso adicionar"
          class="resume-footer__secondary"
          @click.native="finishAttendanceAtReception"
        />
      </footer>
    </section>

    <DrawerBottom :open="openDrawer" @toggle="openDrawer = !openDrawer" @close="openDrawer = false">
      <template #content>
        <div class="drawer-content">
          <AttentionSvg />

          <p>
            O seu convênio não permite adicionar novos exames caso continue o check-in. Se ainda
            precisar adicionar exames no atendimento de hoje, vá à recepção.
          </p>

          <div class="drawer-buttons">
            <VNavButton
              variant="primary"
              text="Continuar meu check-in"
              @click.native="goToCheckinQuestions"
            />
            <VNavButton
              variant="secondary"
              text="Ir pra recepção"
              class="drawer-buttons__secondary"
              @click.native="finishAttendanceAtReception"
            />
          </div>
        </div>
      </template>
    </DrawerBottom>
  </div>
</template>

<script>
import VNavButton from '@/components/commons/VNavButton.vue';
import DrawerBottom from '@/components/drawerBottom.component.vue';
import TheHeader from '@/components/layout/TheHeader';
import { dataLayersMixin } from '@/utils/mixins';

import { mapActions } from 'vuex';

export default {
  name: 'UnscheduledExams',
  mixins: [dataLayersMixin],
  components: {
    VNavButton,
    DrawerBottom,
    TheHeader,
  },
  props: {
    width: {
      type: [Number, String],
      default: 80,
    },
    height: {
      type: [Number, String],
      default: 80,
    },
  },
  data() {
    return {
      openDrawer: false,
    };
  },
  mounted() {
    this.mostCommonPagesAnalytics({
      eventType: 'funnel_step',
      currentStep: 'Tem exames para adicionar na recepção?',
    });
  },
  methods: {
    ...mapActions(['global/skipServiceDeskFlowFail', 'global/setBradescoFlow']),
    triggerConfirmArriving() {
      this.toggleConfirmArrivingModalDisplay(true, false);
    },

    toggleConfirmArrivingModalDisplay(isOpen, notArrived) {
      this.mostCommonPagesAnalytics({
        eventType: 'funnel_step',
        currentStep: 'Tem exames para adicionar na recepção? - drawer de confirmação',
      });

      this.openDrawer = isOpen;
      this.notArrived = notArrived;
    },

    goToCheckinQuestions() {
      this['global/skipServiceDeskFlowFail'](false);
      this['global/setBradescoFlow'](true);
      return this.goNextStep('questions_conclusion_step');
    },

    finishAttendanceAtReception() {
      this['global/skipServiceDeskFlowFail'](true);
      this['global/setBradescoFlow'](false);
      return this.goNextStep('admission_done');
    },
  },
};
</script>

<style lang="scss" scoped>
.unscheduled-exams {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 52px);
  overflow: hidden;

  &__header {
    position: fixed;
    width: calc(100%);
    margin: 0 auto;
    top: 0;
  }

  &__body {
    height: 100%;
    margin: 0 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.message-content {
  padding-top: 132px;
  &__icon {
    width: 80px;
    height: 80px;
  }
  &__text {
    padding-top: 16px;
    width: 328;
    height: 58;
    font-weight: 700;
    font-size: 24px;
    line-height: 120%;
    letter-spacing: 0%;
    text-align: center;
    font-family: 'Dasa Sans', sans-serif;
  }
}
.resume-footer {
  padding: 24px 0 8px;
  display: flex;
  flex-direction: column;
  &__secondary {
    margin-top: 8px;
    width: 313;
    height: 48;
  }
}
.drawer-content {
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #161616;
    margin-bottom: 24px;
  }
  p {
    font-weight: 400;
    font-size: 16px;
    line-height: 18.75px;
    text-align: center;
    color: var(--color-grey-11);
    margin-bottom: 24px;
  }
}
.drawer-buttons {
  display: flex;
  flex-direction: column;
  &__secondary {
    margin-top: 16px;
  }
}
</style>
